import { reaction } from "mobx";
import { useEffect } from "react";

import { useStructuredSearchStore } from "@/components/StructuredSearch";

export const useResetPageOnStructuredSearch = (getSearchSnapshot: () => object) => {
  const structuredSearchStore = useStructuredSearchStore();

  useEffect(
    () =>
      reaction(
        () => ({
          q: structuredSearchStore.q,
          structuredSearchPayload: getSearchSnapshot(),
        }),
        (_, previous) => {
          if (previous) {
            structuredSearchStore.resetToFirstPage();
          }
        },
        { fireImmediately: false },
      ),
    [getSearchSnapshot, structuredSearchStore],
  );
};
